import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material/styles';
import { RouteContainer } from '../../components/route-container';
import { uicolors } from '../../theme';
import { AgentDashboard } from './dashboard';
import { FeaturedPromo } from './featured-promo';
import { QuickLinks } from './quick-links';

export interface ChartRanking {
  AgtNo: string | null;
  AgtName: string | null;
  Total: number | null;
  RingFocusTitle?: string | null;
  RingFocusToolTip?: string | null;
}

export interface HomeDashData {
  IncomeTitle: string | null;
  IncomeTooltip: string | null;
  IncomeValue: number | null;
  UpcomingConvention: string | null;
  BaseshopTixTotal: number | null;
  HierarchyTixTotal: number | null;
  ImgFileLocation: string | null;
  LvlImagePath: string | null;
  NextLvlImagePath: string | null;
  BadgeGeneralInfo: string | null;
  BadgeCurrentLvlInfo: string | null;
  BadgeNextLvlInfo: string | null;
  EmbedURL?: string | null;
  IsPlaylist?: boolean;
  Recruits?: ChartRanking[];
  Onboardings?: ChartRanking[];
  GrossDeposits?: ChartRanking[];
  IPAP?: ChartRanking[];
  NewIPAgents?: ChartRanking[];
  RingFocus?: ChartRanking[];
  RingFocusTitle?: string | null;
  RingFocusToolTip?: string | null;
}

export const homeStyles: { [key: string]: SxProps } = {
  box: {
    letterSpacing: 1.1,
    textAlign: 'center',
    borderRadius: 2,
    border: '1px solid',
    fontSize: { xs: 12, sm: 14 },
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    letterSpacing: 1.1,
    whiteSpace: 'nowrap',
    fontSize: 10,
    borderRadius: 1,
  },
  section: {
    borderRadius: 2,
    px: { xs: 1, lg: 2 },
  },
  title: {
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 1.1,
    color: uicolors.blueNav[950],
  },
};

export function Home() {
  return (
    <RouteContainer routeTitle="Home" withContainer maxWidth="lg">
      <Box sx={{ pt: 2, pb: 4 }}>
        <Stack p={0} spacing={{ xs: 2, md: 3 }}>
          <FeaturedPromo />
          <QuickLinks />
          <AgentDashboard />
        </Stack>
      </Box>
    </RouteContainer>
  );
}
